<template>
  <div :class="horizontal ? 'pricing-flow-horizontal' : 'pricing-flow'">
    <div v-if="isFree" class="pricing-flow-item">
      <span class="price">Free</span>
    </div>
    <div v-if="!isFree && pricing.setup_items" class="pricing-flow-item">
      <span class="price">{{ setupPrice }}</span> setup
    </div>
    <template v-if="!isFree && pricing.monthly.length">
      <div v-for="(monthly, key) in pricing.monthly" class="pricing-flow-item" :key="key">
        <p><span class="price">{{ stepPrice(monthly) }}</span> /month</p>
        <p class="length">for {{ monthly.duration }} month<span v-if="monthly.duration > 1">s</span></p>
      </div>
    </template>
    <template v-if="!isFree && pricing.rolling_items.length">
      <div v-for="(rolling, key) in pricing.rolling_items" class="pricing-flow-item" :key="key">
        <p><span class="price">{{ displayPrice(rolling.price) }}</span> /month</p>
        <p class="length">when out of contract</p>
      </div>
    </template>
  </div>
</template>

<script>
export default {
    props: ["pricing", "horizontal"],

    computed: {
      setupPrice() {
        return this.displayPrice(
              (this.pricing.setup_items || []).reduce(
                  (a, c) => a + c.price,
                  0
              )
          ).replace("£0.00", "Free")
      },

      isFree() {
        let totalPrice = 0;

        for (let pricing of this.pricing.setup_items) {
            totalPrice += pricing.price;
        }

        for (let pricing of this.pricing.monthly) {
            for (let item of pricing.items) {
                totalPrice += item.price;
            }
        }

        for (let pricing of this.pricing.rolling_items) {
            totalPrice += pricing.price;
        }

        return (totalPrice === 0);
      }
    },

    methods: {
      displayPrice(x) {
        return new Intl.NumberFormat("en-GB", {
          style: "currency",
          currency: "GBP",
        }).format(x / 100);
      },
      stepPrice(step) {
        let price = 0;

        step.items.forEach(item => price += item.price);

        return this.displayPrice(price);

      }
    }
}
</script>
